import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { take, map, switchMap, catchError } from 'rxjs/operators';
import { NavController } from '@ionic/angular';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Globals } from '../services/app-globals';
import { BusinessLogicService } from '../services/business-logic.service';
import { FireService } from '../services/fire.service';

@Injectable({
  providedIn: 'root'
})
export class AutomaticLoginGuard implements CanActivate {

  constructor(
    private router: Router,
    private navCtrl: NavController,
    private fireAuth: AngularFireAuth,
    private businessLogicService: BusinessLogicService,
    private fireService: FireService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    console.log("canActivate starting")
    return this.fireAuth.authState.pipe(
      take(1),
      switchMap(async (authState) => {

        // check user is logged in

        // not logged in? navigate to login page
        if (!authState) {
          console.log("canActivate go back")
          return true;
        }

        // here user is logged in
        // decide where to go next
        // this.businessLogicService.setTabSelected(Globals.TABS.DEVICES); 
        console.log("canActivate navigate to /app/main")
        this.navCtrl.navigateRoot('/app/main');
        return false;
      }
      ),
      catchError((error) => {
        console.error(error);
        return of(true);
      })
    );
  }
}
